// removed by extract-text-webpack-plugin
module.exports = {"privacyConsent":"PrivacyConsent__privacyConsent__vUwZK"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PrivacyConsent/PrivacyConsent.css
// module id = 3234
// module chunks = 0